import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

// Function to format numbers as K (thousands), L (lakhs), and Cr (crores)
function formatNumber(value) {
  if (value >= 10000000) {
    return `${(value / 10000000).toFixed(2)} Cr`;
  } else if (value >= 100000) {
    return `${(value / 100000).toFixed(2)} L`;
  } else if (value >= 1000) {
    return `${(value / 1000).toFixed(2)} K`;
  } else {
    return `${value}`;
  }
}

const Spend = ({ stateWisePrice }) => {
  const totalPrice = stateWisePrice.reduce(
    (acc, cur) => acc + cur.totalPrice,
    0
  );

  // Determine dynamic Y-axis scale based on Indian system
  const maxTotalPrice = Math.max(
    ...stateWisePrice.map((item) => item.totalPrice),
    0
  );
  const dynamicMax = Math.ceil(maxTotalPrice / 10000) * 10000; // Rounding to nearest 10,000

  let scaleFactor = 1;
  let suffix = "";

  if (dynamicMax >= 10_000_000) {
    scaleFactor = 10_000_000;
    suffix = "Cr";
  } else if (dynamicMax >= 100_000) {
    scaleFactor = 100_000;
    suffix = "L";
  } else if (dynamicMax >= 1_000) {
    scaleFactor = 1_000;
    suffix = "K";
  }

  // Generate dynamic Y-axis ticks
  const yAxisTicks = Array.from(
    { length: Math.ceil(dynamicMax / scaleFactor) + 1 },
    (_, i) => i * scaleFactor
  );

  return (
    <div className="bg-white min-h-[420px]  rounded-lg  w-full  shadow-lg">
      <div className="text-black text-xl font-bold mb-4 p-6">
        <h2 className="text-lg font-semibold">Spend Allocation Of States</h2>
      </div>
      <p className="text-green-500 px-7 text-3xl">{formatNumber(totalPrice)}</p>
      <div className="w-full h-72 mt-2">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={stateWisePrice}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid horizontal={false} vertical={false} />
            <XAxis dataKey="state" tick={{ fill: "#4B5563" }} />
            <YAxis
              domain={[0, dynamicMax]}
              ticks={yAxisTicks}
              tickFormatter={(value) => `${value / scaleFactor}${suffix}`}
              tick={{ fill: "#4B5563" }}
            />
            <Tooltip formatter={(value) => formatNumber(value)} />
            <Bar dataKey="totalPrice" fill="#D6E3FF" radius={[5, 5, 0, 0]} name="Total Price" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Spend;
